const STORAGE_KEY = 'AgencyThemeColor';

function writeMetaColor(name: string, color: string) {
  const existing = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  const meta = existing ?? document.head.appendChild(document.createElement('meta'));
  meta.name = name;
  meta.content = color;
}

function readRememberedThemeColor(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function rememberThemeColor(themeColor: string) {
  try {
    window.localStorage.setItem(STORAGE_KEY, themeColor);
  } catch {
    return;
  }
}

export function applyAgencyThemeColor(themeColor: string) {
  document.documentElement.style.setProperty('--agency-color', themeColor);
  writeMetaColor('theme-color', themeColor);
  writeMetaColor('msapplication-TileColor', themeColor);
}

export function applyRememberedAgencyThemeColor() {
  const themeColor = readRememberedThemeColor();
  if (themeColor === null || themeColor.length === 0) {
    return;
  }

  applyAgencyThemeColor(themeColor);
}

export function applyAndRememberAgencyThemeColor(themeColor: string) {
  applyAgencyThemeColor(themeColor);
  rememberThemeColor(themeColor);
}
